
import { defineComponent, onMounted, onUnmounted } from 'vue';
import { default as router } from '@/router';

export default defineComponent({
  name: 'Download',
  setup() {
    onMounted(() => {
      document.body.classList.add('otherLayout');
    });
    onUnmounted(() => {
      document.body.classList.remove('otherLayout');
    });
    const downloadExe = () => {
      window.open(
        'https://dfs-mj.oss-cn-beijing.aliyuncs.com/mj-client-setup.exe?' + new Date().getTime(),
        '_blank',
      );
    };
    const goBack = () => {
      router.back();
    };
    return {
      downloadExe,
      goBack,
    };
  },
});
